<template>
  <div>
    <el-dialog title="添加课程" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
      <el-form ref="form" :model="form" label-width="200px">
        <el-form-item label="课程名称">
          <el-input class="max-w460" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="所属分类">
          <el-select size="small" v-model="form.categoryId" placeholder="所有分类">
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.categoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否精选">
          <el-select size="small" v-model="form.lesson_type" placeholder="请选择是否精选">
            <el-option label="非精选课程" :value="0"></el-option>
            <el-option label="精选课程" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程概要">
          <el-input class="max-w460" v-model="form.message"></el-input>
        </el-form-item>
        <el-form-item label="上传视频：">
          <el-row>
            <div class="draggable-list">
              <div class="item img-select" v-if="form.file_address==''" @click="openProductUpload('video', 'video')">
                <i class="el-icon-plus"></i>
              </div>
              <div v-if="form.file_address!=''">
                <video width="150" height="150" :src="form.file_address" :autoplay="false" controls>
                  您的浏览器不支持 video 标签
                </video>
                <div>
                  <el-button icon="el-icon-picture-outline" @click="delVideo">删除视频</el-button>
                </div>
              </div>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item label="课程封面：">
          <el-row>
            <div class="draggable-list">
              <div class="item img-select" v-if="form.imageId==0" @click="openProductUpload('image', 'image')">
                <i class="el-icon-plus"></i>
              </div>
              <div v-if="form.imageId!=0" class="item" @click="openProductUpload('image', 'image')">
                <img :src="image_filePath" width="100" height="100" />
              </div>
            </div>
          </el-row>
        </el-form-item>

        <el-form-item label="排序">
          <el-input class="max-w460" v-model="form.sort" type="number"></el-input>
        </el-form-item>
      </el-form>
      <!--图片组件-->
      <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="onSubmit()" :disabled="submit_loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Technician from "@/api/technician.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  props: ["open_add"],
  data() {
    return {
      form: {
        name: "",
        sort: 100,
        message: "",
        imageId: "",
        lesson_type: 0, //1 精选课程 0 非精选课程
        file_address: ""
      },
      isProductUpload: false,
      file_name: "image",
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      categoryList: [],
      video_id: "",
      image_filePath: ""
    };
  },

  created() {
    this.dialogVisible = this.open_add;
    this.getcalsslist();
  },

  methods: {
    getcalsslist() {
      let self = this;
      Technician.coursegetCategory({}, true)
        .then(data => {
          self.categoryList = data.data.list;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          Technician.courselessonAdd(self.form, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },
    delVideo() {
      this.form.video_id = 0;
      this.form.video = {};
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*打开上传图片*/
    openProductUpload: function(fileType, file_name) {
      this.file_name = file_name;
      if (fileType == "image") {
        this.config = {
          total: 1,
          fileType: "image"
        };
      } else if (fileType == "audio") {
        this.config = {
          total: 1,
          fileType: "audio"
        };
      } else {
        this.config = {
          total: 1,
          fileType: "video"
        };
      }
      this.isProductUpload = true;
    },
    /*上传活动图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        if (this.file_name == "video") {
          this.video_id = e[0].fileId;
          this.form.file_address = e[0].filePath;
        } else if (this.file_name == "image") {
          this.form.imageId = e[0].fileId;
          this.image_filePath = e[0].filePath;
        }
      }
      this.isProductUpload = false;
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/train/center/course/add.vue